const blogPostingSchema = ({
  url,
  title,
  description,
  image,
  datePublished,
  dateModified,
  author,
}) => {
  const getAbsoluteUrl = (path) => {
    if (!path) return undefined;

    return path.startsWith("http")
      ? path
      : `https://irisimpulse.com/${path.replace(/^\/+/, "")}`;
  };

  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "@id": `${url}#article`,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url,
    },
    headline: title,
    description,
    ...(image && {
      image: [getAbsoluteUrl(image)],
    }),
    ...(datePublished && {
      datePublished,
    }),
    ...(dateModified && {
      dateModified,
    }),
    author: {
      "@type": "Organization",
      "@id": "https://irisimpulse.com/#organization",
      name: author || "Iris Impulse India Pvt. Ltd.",
    },
    publisher: {
      "@type": "Organization",
      "@id": "https://irisimpulse.com/#organization",
      name: "Iris Impulse India Pvt. Ltd.",
      logo: {
        "@type": "ImageObject",
        url: "https://irisimpulse.com/logo.png",
      },
    },
    inLanguage: "en",
  };
};

export default blogPostingSchema;